<template>
  <div class="records-toolbar">
    <span class="record-count-badge">
      Total de <strong>{{ total }}</strong> {{ total === 1 ? 'registro' : 'registros' }}
    </span>
  </div>
</template>

<script>
export default {
  name: "TotalRecordsBadge",
  props: {
    total: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.records-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 0;
}

.record-count-badge {
  padding: 4px 10px;
  color: #333;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  font-size: 12px;
}

.dark-theme .record-count-badge {
  color: #f3f4f6;
  background: transparent;
  border: 1px solid #f3f4f6;
}

.record-count-badge strong {
  font-weight: 700;
}
</style>
